declare const __APP_VERSION__: string;

/** Версия сборки из deploy/update.sh: «1.2.5-1a2b3c4» (версия и хэш коммита), «dev» — локально. */
export const APP_VERSION = __APP_VERSION__;

/** «1.2.5-1a2b3c4» → { version: '1.2.5', commit: '1a2b3c4' }; другие строки — версия как есть. */
export function parseVersion(v: string): { version: string; commit: string } {
  const m = /^(\d+\.\d+\.\d+)-([0-9a-f]{7,})$/.exec(v);
  return m ? { version: m[1]!, commit: m[2]! } : { version: v, commit: '' };
}
